import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, shadow, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  z-index: 1;

  &[data-open='true'] {
    z-index: ${layout.zIndexDropdown};
  }
`;

export const Trigger = styled.button<{ $variant?: 'default' | 'pill' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-200']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: ${(p) => (p.$variant === 'pill' ? '20px 12px' : '10px 12px')};
  border: ${(p) => (p.$variant === 'pill' ? 'none' : `1px solid ${semantic.border.default}`)};
  border-radius: ${(p) => (p.$variant === 'pill' ? '100px' : '8px')};
  background: ${(p) => (p.$variant === 'pill' ? semantic.bg.surfaceSubtle : semantic.bg.canvas)};
  color: ${semantic.text.primary};
  cursor: pointer;
  outline: none;
  min-width: 100px;
  width: 100%;
  text-align: left;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:focus {
    border-color: ${(p) => (p.$variant === 'pill' ? 'transparent' : semantic.border.selected)};
    background: ${(p) => (p.$variant === 'pill' ? semantic.bg.surfaceDefault : semantic.bg.canvas)};
  }

  &[data-open='true'] {
    border-color: ${(p) => (p.$variant === 'pill' ? 'transparent' : semantic.border.selected)};
    background: ${(p) => (p.$variant === 'pill' ? semantic.bg.surfaceDefault : semantic.bg.canvas)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-error='true'] {
    border-color: ${semantic.border.danger};
    box-shadow: ${(p) => (p.$variant === 'pill' ? `0 0 0 1px ${semantic.border.danger}` : 'none')};
  }
`;

export const TriggerText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Placeholder = styled.span`
  color: ${semantic.text.tertiary};
`;

export const Chevron = styled.span<{ $open: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.15s ease;
  transform: ${(p) => (p.$open ? 'rotate(180deg)' : 'rotate(0deg)')};
  color: ${semantic.text.secondary};
`;

export const OptionsList = styled.ul`
  position: absolute;
  top: calc(100% + ${space['space-100']});
  right: 0;
  z-index: 200;
  box-sizing: border-box;
  margin: 0;
  padding: ${space['space-600']} 0;
  list-style: none;
  background: ${semantic.bg.canvas};
  border: none;
  border-radius: ${size.radius['radius-xxl']};
  box-shadow: ${shadow.lg};
  overflow: hidden;
  max-height: 360px;
  white-space: nowrap;
  min-width: 100%;
  display: flex;
  flex-direction: column;

  &[data-align='left'] {
    right: auto;
    left: 0;
  }
`;

export const SearchInput = styled.input`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  padding: 0 ${space['space-600']} ${space['space-400']};
  border: none;
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;

  &::placeholder {
    color: ${semantic.text.tertiary};
  }
`;

export const OptionsContainer = styled.div`
  overflow-y: auto;
  flex: 1;
`;

export const Option = styled.li`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  box-sizing: border-box;
  min-height: ${primitives.size['size-1200']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  padding: 0 ${space['space-600']};
  cursor: pointer;
  color: ${semantic.text.primary};
  transition: background 0.1s ease;

  &:hover,
  &[data-active='true'] {
    background: ${semantic.bg.surfaceSubtle};
  }

  &[data-selected='true'] {
    font-weight: ${fonts.weight.semiBold};
  }

  &[data-disabled='true'] {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
